/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Body Render Definitions Mapping 

import {
	RESOURCE_TYPE_USER_ACCOUNT,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE,
	RESOURCE_TYPE_USER_HISTORY_ENTRY,
	RESOURCE_TYPE_BALANCE_CHANGE_LOG,
	RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA,
	RESOURCE_TYPE_USER_ACCOUNT_SETTINGS,
	RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST,
	RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION,
	RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING,
	RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS,
	RESOURCE_TYPE_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_PASSWORD,
	RESOURCE_TYPE_EXPIRED_PASSWORD,
	RESOURCE_TYPE_PASSWORD_RESET,
	RESOURCE_TYPE_DEPOSIT,
	RESOURCE_TYPE_DEPOSIT_INVITE,
	RESOURCE_TYPE_DEPOSIT_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_INTEREST,
	RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY,
	RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_USER_STATS,
	RESOURCE_TYPE_DEPOSIT_BANK_MAPPING,
	RESOURCE_TYPE_DEPOSITS_BULK_IMPORT,
	RESOURCE_TYPE_DEPOSIT_INTEREST_LOG,
	RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS,
	RESOURCE_TYPE_PMC_REPORT_TIMETABLE,
	RESOURCE_TYPE_DEPOSIT_GROUP,
	RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_USER_GROUP,
	RESOURCE_TYPE_PROPERTY_GROUP,
	RESOURCE_TYPE_PROPERTY_USER_GROUP,
	RESOURCE_TYPE_DISPUTE,
	RESOURCE_TYPE_DISPUTE_SPLIT,
	RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST,
	RESOURCE_TYPE_PROPERTY,
	RESOURCE_TYPE_PROPERTY_ADDRESS,
	RESOURCE_TYPE_COMPLIANCE,
	RESOURCE_TYPE_COMPLIANCE_RULE,
	RESOURCE_TYPE_COMPLIANCE_HISTORY,
	RESOURCE_TYPE_EMAIL_TEMPLATE,
	RESOURCE_TYPE_EMAIL_VERIFICATION,
	RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD,
	RESOURCE_TYPE_EMAIL_EVENT,
	RESOURCE_TYPE_SENT_EMAIL,
	RESOURCE_TYPE_MAILBOX,
	RESOURCE_TYPE_MAILBOX_META_DATA,
	RESOURCE_TYPE_MAILBOX_MESSAGE,
	RESOURCE_TYPE_PERMISSION_ENTRY,
	RESOURCE_TYPE_PERMISSION_LOG_ENTRY,
	RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS,
	RESOURCE_TYPE_RESOURCE_PERMISSIONS,
	RESOURCE_TYPE_ORGANIZATION,
	RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE,
	RESOURCE_TYPE_INVOICE,
	RESOURCE_TYPE_INVOICE_ITEM,
	RESOURCE_TYPE_PAYMENT_REQUEST,
	RESOURCE_TYPE_STRIPE_PAYMENT_LOG,
	RESOURCE_TYPE_USER_WITHDRAW,
	RESOURCE_TYPE_PRIORITY_ACH_PAYMENT,
	RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT,
	RESOURCE_TYPE_LOAN_APPLICATION,
	RESOURCE_TYPE_LOAN_SYSTEM_INFO,
	RESOURCE_TYPE_LOAN,
	RESOURCE_TYPE_LOAN_HISTORY,
	RESOURCE_TYPE_LOAN_PAYMENT_LOG,
	RESOURCE_TYPE_STRIPE_WEBHOOK_LOG,
	RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO,
	RESOURCE_TYPE_SEZZLE_ORDER,
	RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT,
	RESOURCE_TYPE_BANK_ACCOUNT,
	RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE,
	RESOURCE_TYPE_BANK_ACCOUNT_INTEREST,
	RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD,
	RESOURCE_TYPE_BANK_TRANSFER,
	RESOURCE_TYPE_BULK_FUNDS_TRANSFER,
	RESOURCE_TYPE_FUNDS_LOCK,
	RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG,
	RESOURCE_TYPE_RELEASED_FUNDS_LOCK,
	RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER,
	RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG,
	RESOURCE_TYPE_EVENT,
	RESOURCE_TYPE_EVENT_HOOK,
	RESOURCE_TYPE_NOTIFICATION,
	RESOURCE_TYPE_ACTION_ITEM,
	RESOURCE_TYPE_UPDATE_LOG_ENTRY,
	RESOURCE_TYPE_STORAGE_FILE,
	RESOURCE_TYPE_ATTACHED_STORAGE_FILES,
	RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY,
	RESOURCE_TYPE_SNAPSHOT,
	RESOURCE_TYPE_IP_ADDRESS,
	RESOURCE_TYPE_KNOWN_IP_ADDRESS,
	RESOURCE_TYPE_USER_AGENT,
	RESOURCE_TYPE_KNOWN_USER_AGENT,
	RESOURCE_TYPE_SYSTEM_STATS,
	RESOURCE_TYPE_RESOURCE_NOTE,
	RESOURCE_TYPE_DEPOSIFY_TAG,
	RESOURCE_TYPE_PERMANENT_LINK,
	RESOURCE_TYPE_ONLINE_USER,
	RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS,
	RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS,
	RESOURCE_TYPE_YARDI_VOYAGER_PET,
	RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_PHONE,
	RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR,
	RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY,
	RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS
} from "./resourceTypeConstants";
import {
	BANK_ACCOUNT_BALANCE_RECORD_BODY_RENDER_DEF,
	BANK_ACCOUNT_BODY_RENDER_DEF,
	BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_BODY_RENDER_DEF,
	BANK_ACCOUNT_INTEREST_BODY_RENDER_DEF,
	BANK_TRANSFER_BODY_RENDER_DEF,
	BULK_FUNDS_TRANSFER_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/BankingServiceBodyRenderDefinitions.js";

import {
	ARCHIVED_DEPOSIT_CLOSE_REQUEST_BODY_RENDER_DEF,
	COMPLIANCE_BODY_RENDER_DEF,
	COMPLIANCE_HISTORY_BODY_RENDER_DEF,
	COMPLIANCE_RULE_BODY_RENDER_DEF,
	DEPOSIT_BODY_RENDER_DEF,
	DEPOSIT_ADJUSTMENT_BODY_RENDER_DEF,
	DEPOSIT_BANK_MAPPING_BODY_RENDER_DEF,
	DEPOSIT_BULK_IMPORT_BODY_RENDER_DEF,
	DEPOSIT_CLOSE_REQUEST_BODY_RENDER_DEF,
	DEPOSIT_GROUP_BODY_RENDER_DEF,
	DEPOSIT_INTEREST_BODY_RENDER_DEF,
	DEPOSIT_INTEREST_LOG_BODY_RENDER_DEF,
	DEPOSIT_INVITE_BODY_RENDER_DEF,
	DEPOSIT_POST_CLOSE_ADJUSTMENT_BODY_RENDER_DEF,
	DEPOSIT_USER_GROUP_BODY_RENDER_DEF,
	DEPOSIT_USER_STATS_BODY_RENDER_DEF,
	DEPOSIT_WITHHELD_FUNDS_BODY_RENDER_DEF,
	DISPUTE_BODY_RENDER_DEF,
	DISPUTE_INTERVENTION_REQUEST_BODY_RENDER_DEF,
	DISPUTE_SPLIT_BODY_RENDER_DEF,
	PMC_REPORT_TIMETABLE_BODY_RENDER_DEF,
	PROPERTY_BODY_RENDER_DEF,
	PROPERTY_ADDRESS_BODY_RENDER_DEF,
	PROPERTY_GROUP_BODY_RENDER_DEF,
	PROPERTY_USER_GROUP_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/DepositsServiceBodyRenderDefinitions.js";

import {
	ACTION_ITEM_BODY_RENDER_DEF,
	EVENT_HOOK_BODY_RENDER_DEF,
	EVENT_BODY_RENDER_DEF,
	NOTIFICATION_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/EventsServiceBodyRenderDefinitions.js";

import {
	FRONTEND_GENERAL_SETTINGS_BODY_RENDER_DEF,
	ONLINE_USER_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/FrontendServiceBodyRenderDefinitions.js";

import {
	SNAPSHOT_BODY_RENDER_DEF,
	SYSTEM_HISTORY_ENTRY_BODY_RENDER_DEF,
	DEPOSIT_HISTORY_ENTRY_BODY_RENDER_DEF,
	UPDATE_LOG_BODY_RENDER_DEF,
	USER_HISTORY_ENTRY_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/HistoryServiceBodyRenderDefinitions.js";

import {
	EMAIL_EVENT_BODY_RENDER_DEF,
	EMAIL_TEMPLATE_BODY_RENDER_DEF,
	MAILBOX_BODY_RENDER_DEF,
	MAILBOX_MESSAGE_BODY_RENDER_DEF,
	MAILBOX_META_DATA_BODY_RENDER_DEF,
	SENT_EMAIL_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/MessagingServiceBodyRenderDefinitions.js";

import {
	INVOICE_BODY_RENDER_DEF,
	INVOICE_ITEM_BODY_RENDER_DEF,
	LOAN_BODY_RENDER_DEF,
	LOAN_APPLICATION_BODY_RENDER_DEF,
	LOAN_HISTORY_BODY_RENDER_DEF,
	LOAN_PAYMENT_LOG_BODY_RENDER_DEF,
	LOAN_SYSTEM_INFO_BODY_RENDER_DEF,
	PAYMENT_REQUEST_BODY_RENDER_DEF,
	PRIORITY_ACH_PAYMENT_BODY_RENDER_DEF,
	PRIORITY_ACH_RECURRING_PAYMENT_BODY_RENDER_DEF,
	SEZZLE_ORDER_BODY_RENDER_DEF,
	SEZZLE_WEBHOOK_EVENT_BODY_RENDER_DEF,
	STRIPE_PAYMENT_LOG_BODY_RENDER_DEF,
	STRIPE_WEBHOOK_LOG_BODY_RENDER_DEF,
	USER_ACCOUNT_PAYMENT_PROVIDER_INFO_BODY_RENDER_DEF,
	USER_WITHDRAW_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/PaymentsServiceBodyRenderDefinitions.js";

import {
	ORGANIZATION_BODY_RENDER_DEF,
	ORGANIZATION_RESOURCE_PERMISSION_RULE_BODY_RENDER_DEF,
	PERMISSIONS_ORGANIZATION_SETTINGS_BODY_RENDER_DEF,
	PERMISSION_ENTRY_BODY_RENDER_DEF,
	PERMISSION_LOG_ENTRY_BODY_RENDER_DEF,
	RESOURCE_PERMISSION_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/PermissionsServiceBodyRenderDefinitions.js";

import {

} from "../../clientShared/constants/bodies/renderDefinitions/SearchServiceBodyRenderDefinitions.js";

import {
	IP_ADDRESS_BODY_RENDER_DEF,
	KNOWN_IP_ADDRESS_BODY_RENDER_DEF,
	KNOWN_USER_AGENT_BODY_RENDER_DEF,
	USER_AGENT_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/SecurityServiceBodyRenderDefinitions.js";

import {
	ATTACHED_STORAGE_FILES_BODY_RENDER_DEF,
	STORAGE_FILE_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/StorageServiceBodyRenderDefinitions.js";

import {
	DEPOSIFY_TAG_BODY_RENDER_DEF,
	PERMANENT_LINK_BODY_RENDER_DEF,
	RESOURCE_NOTE_BODY_RENDER_DEF,
	SYSTEM_STATS_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/SystemGeneralServiceBodyRenderDefinitions.js";

import {
	ADMIN_GHOST_USER_ACCOUNT_BODY_RENDER_DEF,
	ARCHIVED_PENDING_EMAIL_CHANGE_BODY_RENDER_DEF,
	BALANCE_CHANGE_LOG_BODY_RENDER_DEF,
	BALANCE_SOURCE_TRANSFER_BODY_RENDER_DEF,
	CREDIT_USER_ACCOUNT_LOG_BODY_RENDER_DEF,
	EMAIL_VERIFICATION_BODY_RENDER_DEF,
	EMAIL_VERIFICATION_RECORD_BODY_RENDER_DEF,
	EXPIRED_PASSWORD_BODY_RENDER_DEF,
	FUNDS_LOCK_BODY_RENDER_DEF,
	FUNDS_LOCK_RELEASE_LOG_BODY_RENDER_DEF,
	INTERNATIONAL_USER_BANK_ACCOUNT_BODY_RENDER_DEF,
	PASSWORD_BODY_RENDER_DEF,
	PASSWORD_RESET_BODY_RENDER_DEF,
	PENDING_EMAIL_CHANGE_BODY_RENDER_DEF,
	PREVIOUS_EMAIL_ADDRESS_BODY_RENDER_DEF,
	RELEASED_FUNDS_LOCK_BODY_RENDER_DEF,
	THIRD_PARTY_USER_ACCOUNT_MAPPING_BODY_RENDER_DEF,
	USER_ACCOUNT_BODY_RENDER_DEF,
	USER_ACCOUNT_BALANCE_BODY_RENDER_DEF,
	USER_ACCOUNT_BALANCE_SOURCE_BODY_RENDER_DEF,
	USER_ACCOUNT_FINALIZATION_BODY_RENDER_DEF,
	USER_ACCOUNT_SETTINGS_BODY_RENDER_DEF,
	USER_BANK_ACCOUNT_DELTA_BODY_RENDER_DEF,
	US_DOMESTIC_USER_BANK_ACCOUNT_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/UserAccountsServiceBodyRenderDefinitions.js";

import {
	YARDI_SCREENING_WORKS_PRO_XML_BODY_RENDER_DEF,
	YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_BODY_RENDER_DEF,
	YARDI_VOYAGER_CHARGE_BODY_RENDER_DEF,
	YARDI_VOYAGER_CHARGE_CODE_BODY_RENDER_DEF,
	YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_BODY_RENDER_DEF,
	YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_BODY_RENDER_DEF,
	YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_BODY_RENDER_DEF,
	YARDI_VOYAGER_EVENT_BODY_RENDER_DEF,
	YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_BODY_RENDER_DEF,
	YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_BODY_RENDER_DEF,
	YARDI_VOYAGER_OTHER_OCCUPANT_BODY_RENDER_DEF,
	YARDI_VOYAGER_PET_BODY_RENDER_DEF,
	YARDI_VOYAGER_PHONE_BODY_RENDER_DEF,
	YARDI_VOYAGER_PMC_BODY_RENDER_DEF,
	YARDI_VOYAGER_PMC_CREDENTIALS_BODY_RENDER_DEF,
	YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_BODY_RENDER_DEF,
	YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_BODY_RENDER_DEF,
	YARDI_VOYAGER_PMC_STATS_BODY_RENDER_DEF,
	YARDI_VOYAGER_PMC_STATS_COLLECTOR_BODY_RENDER_DEF,
	YARDI_VOYAGER_PROPERTY_BODY_RENDER_DEF,
	YARDI_VOYAGER_PROPERTY_UNIT_BODY_RENDER_DEF,
	YARDI_VOYAGER_RESIDENT_BODY_RENDER_DEF,
	YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_BODY_RENDER_DEF,
	YARDI_VOYAGER_SYSTEM_SETTINGS_BODY_RENDER_DEF,
	YARDI_VOYAGER_TRANSACTION_BODY_RENDER_DEF,
	YARDI_VOYAGER_XML_BODY_RENDER_DEF
} from "../../clientShared/constants/bodies/renderDefinitions/YardiServiceBodyRenderDefinitions.js";
export const RESOURCE_TO_BODY_RENDER_DEFINITION = {
	[RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD]: BANK_ACCOUNT_BALANCE_RECORD_BODY_RENDER_DEF,
	[RESOURCE_TYPE_BANK_ACCOUNT]: BANK_ACCOUNT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE]: BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_BANK_ACCOUNT_INTEREST]: BANK_ACCOUNT_INTEREST_BODY_RENDER_DEF,
	[RESOURCE_TYPE_BANK_TRANSFER]: BANK_TRANSFER_BODY_RENDER_DEF,
	[RESOURCE_TYPE_BULK_FUNDS_TRANSFER]: BULK_FUNDS_TRANSFER_BODY_RENDER_DEF,
	[RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST]: ARCHIVED_DEPOSIT_CLOSE_REQUEST_BODY_RENDER_DEF,
	[RESOURCE_TYPE_COMPLIANCE]: COMPLIANCE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_COMPLIANCE_HISTORY]: COMPLIANCE_HISTORY_BODY_RENDER_DEF,
	[RESOURCE_TYPE_COMPLIANCE_RULE]: COMPLIANCE_RULE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT]: DEPOSIT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT_ADJUSTMENT]: DEPOSIT_ADJUSTMENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT_BANK_MAPPING]: DEPOSIT_BANK_MAPPING_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSITS_BULK_IMPORT]: DEPOSIT_BULK_IMPORT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST]: DEPOSIT_CLOSE_REQUEST_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT_GROUP]: DEPOSIT_GROUP_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT_INTEREST]: DEPOSIT_INTEREST_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT_INTEREST_LOG]: DEPOSIT_INTEREST_LOG_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT_INVITE]: DEPOSIT_INVITE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT]: DEPOSIT_POST_CLOSE_ADJUSTMENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT_USER_GROUP]: DEPOSIT_USER_GROUP_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT_USER_STATS]: DEPOSIT_USER_STATS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS]: DEPOSIT_WITHHELD_FUNDS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DISPUTE]: DISPUTE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST]: DISPUTE_INTERVENTION_REQUEST_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DISPUTE_SPLIT]: DISPUTE_SPLIT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PMC_REPORT_TIMETABLE]: PMC_REPORT_TIMETABLE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PROPERTY]: PROPERTY_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PROPERTY_ADDRESS]: PROPERTY_ADDRESS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PROPERTY_GROUP]: PROPERTY_GROUP_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PROPERTY_USER_GROUP]: PROPERTY_USER_GROUP_BODY_RENDER_DEF,
	[RESOURCE_TYPE_ACTION_ITEM]: ACTION_ITEM_BODY_RENDER_DEF,
	[RESOURCE_TYPE_EVENT_HOOK]: EVENT_HOOK_BODY_RENDER_DEF,
	[RESOURCE_TYPE_EVENT]: EVENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_NOTIFICATION]: NOTIFICATION_BODY_RENDER_DEF,
	[RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS]: FRONTEND_GENERAL_SETTINGS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_ONLINE_USER]: ONLINE_USER_BODY_RENDER_DEF,
	[RESOURCE_TYPE_SNAPSHOT]: SNAPSHOT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY]: SYSTEM_HISTORY_ENTRY_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY]: DEPOSIT_HISTORY_ENTRY_BODY_RENDER_DEF,
	[RESOURCE_TYPE_UPDATE_LOG_ENTRY]: UPDATE_LOG_BODY_RENDER_DEF,
	[RESOURCE_TYPE_USER_HISTORY_ENTRY]: USER_HISTORY_ENTRY_BODY_RENDER_DEF,
	[RESOURCE_TYPE_EMAIL_EVENT]: EMAIL_EVENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_EMAIL_TEMPLATE]: EMAIL_TEMPLATE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_MAILBOX]: MAILBOX_BODY_RENDER_DEF,
	[RESOURCE_TYPE_MAILBOX_MESSAGE]: MAILBOX_MESSAGE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_MAILBOX_META_DATA]: MAILBOX_META_DATA_BODY_RENDER_DEF,
	[RESOURCE_TYPE_SENT_EMAIL]: SENT_EMAIL_BODY_RENDER_DEF,
	[RESOURCE_TYPE_INVOICE]: INVOICE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_INVOICE_ITEM]: INVOICE_ITEM_BODY_RENDER_DEF,
	[RESOURCE_TYPE_LOAN]: LOAN_BODY_RENDER_DEF,
	[RESOURCE_TYPE_LOAN_APPLICATION]: LOAN_APPLICATION_BODY_RENDER_DEF,
	[RESOURCE_TYPE_LOAN_HISTORY]: LOAN_HISTORY_BODY_RENDER_DEF,
	[RESOURCE_TYPE_LOAN_PAYMENT_LOG]: LOAN_PAYMENT_LOG_BODY_RENDER_DEF,
	[RESOURCE_TYPE_LOAN_SYSTEM_INFO]: LOAN_SYSTEM_INFO_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PAYMENT_REQUEST]: PAYMENT_REQUEST_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PRIORITY_ACH_PAYMENT]: PRIORITY_ACH_PAYMENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT]: PRIORITY_ACH_RECURRING_PAYMENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_SEZZLE_ORDER]: SEZZLE_ORDER_BODY_RENDER_DEF,
	[RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT]: SEZZLE_WEBHOOK_EVENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_STRIPE_PAYMENT_LOG]: STRIPE_PAYMENT_LOG_BODY_RENDER_DEF,
	[RESOURCE_TYPE_STRIPE_WEBHOOK_LOG]: STRIPE_WEBHOOK_LOG_BODY_RENDER_DEF,
	[RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO]: USER_ACCOUNT_PAYMENT_PROVIDER_INFO_BODY_RENDER_DEF,
	[RESOURCE_TYPE_USER_WITHDRAW]: USER_WITHDRAW_BODY_RENDER_DEF,
	[RESOURCE_TYPE_ORGANIZATION]: ORGANIZATION_BODY_RENDER_DEF,
	[RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE]: ORGANIZATION_RESOURCE_PERMISSION_RULE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS]: PERMISSIONS_ORGANIZATION_SETTINGS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PERMISSION_ENTRY]: PERMISSION_ENTRY_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PERMISSION_LOG_ENTRY]: PERMISSION_LOG_ENTRY_BODY_RENDER_DEF,
	[RESOURCE_TYPE_RESOURCE_PERMISSIONS]: RESOURCE_PERMISSION_BODY_RENDER_DEF,
	[RESOURCE_TYPE_IP_ADDRESS]: IP_ADDRESS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_KNOWN_IP_ADDRESS]: KNOWN_IP_ADDRESS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_KNOWN_USER_AGENT]: KNOWN_USER_AGENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_USER_AGENT]: USER_AGENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_ATTACHED_STORAGE_FILES]: ATTACHED_STORAGE_FILES_BODY_RENDER_DEF,
	[RESOURCE_TYPE_STORAGE_FILE]: STORAGE_FILE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_DEPOSIFY_TAG]: DEPOSIFY_TAG_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PERMANENT_LINK]: PERMANENT_LINK_BODY_RENDER_DEF,
	[RESOURCE_TYPE_RESOURCE_NOTE]: RESOURCE_NOTE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_SYSTEM_STATS]: SYSTEM_STATS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST]: ADMIN_GHOST_USER_ACCOUNT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE]: ARCHIVED_PENDING_EMAIL_CHANGE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_BALANCE_CHANGE_LOG]: BALANCE_CHANGE_LOG_BODY_RENDER_DEF,
	[RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER]: BALANCE_SOURCE_TRANSFER_BODY_RENDER_DEF,
	[RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG]: CREDIT_USER_ACCOUNT_LOG_BODY_RENDER_DEF,
	[RESOURCE_TYPE_EMAIL_VERIFICATION]: EMAIL_VERIFICATION_BODY_RENDER_DEF,
	[RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD]: EMAIL_VERIFICATION_RECORD_BODY_RENDER_DEF,
	[RESOURCE_TYPE_EXPIRED_PASSWORD]: EXPIRED_PASSWORD_BODY_RENDER_DEF,
	[RESOURCE_TYPE_FUNDS_LOCK]: FUNDS_LOCK_BODY_RENDER_DEF,
	[RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG]: FUNDS_LOCK_RELEASE_LOG_BODY_RENDER_DEF,
	[RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT]: INTERNATIONAL_USER_BANK_ACCOUNT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PASSWORD]: PASSWORD_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PASSWORD_RESET]: PASSWORD_RESET_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PENDING_EMAIL_CHANGE]: PENDING_EMAIL_CHANGE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS]: PREVIOUS_EMAIL_ADDRESS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_RELEASED_FUNDS_LOCK]: RELEASED_FUNDS_LOCK_BODY_RENDER_DEF,
	[RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING]: THIRD_PARTY_USER_ACCOUNT_MAPPING_BODY_RENDER_DEF,
	[RESOURCE_TYPE_USER_ACCOUNT]: USER_ACCOUNT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_USER_ACCOUNT_BALANCE]: USER_ACCOUNT_BALANCE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE]: USER_ACCOUNT_BALANCE_SOURCE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION]: USER_ACCOUNT_FINALIZATION_BODY_RENDER_DEF,
	[RESOURCE_TYPE_USER_ACCOUNT_SETTINGS]: USER_ACCOUNT_SETTINGS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA]: USER_BANK_ACCOUNT_DELTA_BODY_RENDER_DEF,
	[RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT]: US_DOMESTIC_USER_BANK_ACCOUNT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML]: YARDI_SCREENING_WORKS_PRO_XML_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY]: YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE]: YARDI_VOYAGER_CHARGE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE]: YARDI_VOYAGER_CHARGE_CODE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT]: YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT]: YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT]: YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_EVENT]: YARDI_VOYAGER_EVENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT]: YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT]: YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT]: YARDI_VOYAGER_OTHER_OCCUPANT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_PET]: YARDI_VOYAGER_PET_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_PHONE]: YARDI_VOYAGER_PHONE_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC]: YARDI_VOYAGER_PMC_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS]: YARDI_VOYAGER_PMC_CREDENTIALS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS]: YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION]: YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS]: YARDI_VOYAGER_PMC_STATS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR]: YARDI_VOYAGER_PMC_STATS_COLLECTOR_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY]: YARDI_VOYAGER_PROPERTY_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT]: YARDI_VOYAGER_PROPERTY_UNIT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT]: YARDI_VOYAGER_RESIDENT_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN]: YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS]: YARDI_VOYAGER_SYSTEM_SETTINGS_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION]: YARDI_VOYAGER_TRANSACTION_BODY_RENDER_DEF,
	[RESOURCE_TYPE_YARDI_VOYAGER_XML]: YARDI_VOYAGER_XML_BODY_RENDER_DEF
};


export function getBodyRenderDefinition(resourceType){
    const returnValue = RESOURCE_TO_BODY_RENDER_DEFINITION[resourceType];
    if(returnValue === undefined){
        throw new Error(`getBodyRenderDefinition for ${resourceType} failed`);
    }
    return returnValue;
}
    